import PropTypes from 'prop-types';

// import Recommended from './Recommended';
import Categories from './Categories';

import Styles from './Blog.module.scss';

const PostMobileFooter = ({ className, recommended, ...props }) => (
  <div className={Styles.postFooter}>
    <Categories />
    {/* <Recommended style={{ marginBottom: '25px' }} articles={recommended} /> */}
  </div>
);

PostMobileFooter.propTypes = {
  recommended: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};

export default PostMobileFooter;
